import React, { useContext } from 'react'
import { graphql, useStaticQuery, Link } from 'gatsby'
import { getImage, GatsbyImage } from 'gatsby-plugin-image'
import slugify from 'slugify'
import { useTheme, makeStyles } from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import FontContext from '../context/fontsize/fontContext'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import Avatar from '@material-ui/core/Avatar'
import { fade } from '@material-ui/core/styles/colorManipulator'
import profilepic from '../assets/images/profilepic.jpg'

const query = graphql`
	{
		allContentfulBlogPost(sort: { fields: createdAt, order: DESC }, limit: 1) {
			nodes {
				id
				title
				shortTitle
				createdAt(formatString: "MMM d")
				image {
					gatsbyImageData(
						layout: CONSTRAINED
						placeholder: BLURRED
						height: 320
					)
				}
				body {
					body
				}
				tags {
					tags
				}
			}
		}
		site {
			siteMetadata {
				author
				description
			}
		}
	}
`

const useStyles = makeStyles((theme) => ({
	outerCtr: {
		// paddingLeft: 100,

		[theme.breakpoints.down('sm')]: {
			// paddingLeft: 50,
		},
		[theme.breakpoints.down('xs')]: {
			padding: '2em 0px',
			marginTop: '-41px',
			paddingBottom: '2em',
		},
	},
	title: {
		paddingTop: '.75em',
		color: theme.palette.common.accent,
		fontSize: '1.25rem',
		fontWeight: 700,
		[theme.breakpoints.up('sm')]: {
			fontWeight: 500,
		},
	},
	lightTitle: {
		paddingTop: '.75em',
		color: theme.palette.common.accent,
		fontSize: '1.25rem',
		fontWeight: 700,
		[theme.breakpoints.up('sm')]: {
			fontWeight: 500,
		},
	},
	shortTitle: {
		color: 'lightgrey',
		paddingTop: '.25em',
	},
	lightShortTitle: {
		color: 'rgba(117, 117, 117, 1)',
		paddingTop: '.25em',
	},
	tags: {
		color: 'grey',
		fontSize: '.8rem',
		marginBottom: 3,
		fontWeight: 400,
	},
	lightTags: {
		color: '#292929',
		fontSize: '.8rem',
		marginBottom: 3,
		fontWeight: 400,
	},
	date: {
		color: 'lightgrey',
		fontSize: '.8rem',
	},
	lightDate: {
		color: '#757575',
		fontSize: '.8rem',
	},
	avatar: {
		border: `1px solid ${fade(theme.palette.common.accent, 0.5)}`,
	},
}))

export default function ArticlesIndex({ data }) {
	const classes = useStyles()
	const theme = useTheme()

	const {
		allContentfulBlogPost: { nodes: posts },
		site: { siteMetadata: meta },
	} = useStaticQuery(query)
	const fontContext = useContext(FontContext)
	const { darkMode } = fontContext

	const sm = useMediaQuery(theme.breakpoints.only('sm'))
	const aboveMD = useMediaQuery(theme.breakpoints.up('md'))
	const matchesLG = useMediaQuery(theme.breakpoints.only('lg'))
	return (
		<Grid container direction='column' className={classes.outerCtr}>
			<Grid item>
				{posts.map((post) => {
					const image = getImage(post.image)
					const slug = slugify(post.title, { lower: true })

					return (
						<Grid container key={post.id}>
							<Grid item xs={12} md={12} lg={11}>
								<Link
									to={`/articles/${slug}`}
									style={{
										textDecoration: 'none',
									}}
								>
									<GatsbyImage
										image={image}
										alt={post.title}
										style={{
											width: '100%',
										}}
									/>
								</Link>
							</Grid>
							<Grid item xs={12}>
								<Link
									to={`/articles/${slug}`}
									style={{
										textDecoration: 'none',
									}}
								>
									<Typography
										variant='h6'
										className={darkMode ? classes.title : classes.lightTitle}
									>
										{post.title}
									</Typography>
								</Link>
							</Grid>
							<Grid item xs={12}>
								<Link
									to={`/articles/${slug}`}
									style={{
										textDecoration: 'none',
									}}
								>
									<Typography
										variant='subtitle1'
										className={
											darkMode ? classes.shortTitle : classes.lightShortTitle
										}
									>
										{post.shortTitle}
									</Typography>
								</Link>
							</Grid>
							<Grid item xs={12}>
								<Grid container style={{ paddingTop: '.5em' }}>
									<Grid
										item
										xs={2}
										md={1}
										style={{
											marginRight: sm
												? '-1.55em'
												: aboveMD
												? '0.75em'
												: matchesLG
												? '-2em'
												: '-.25em',
										}}
									>
										<Grid container>
											<Avatar className={classes.avatar} src={profilepic} />
										</Grid>
									</Grid>
									<Grid item>
										<Grid container direction='column'>
											<Grid item xs={12}>
												{meta.author}
											</Grid>
											<Grid item xs={12}>
												<Link
													to={`/articles/${slug}`}
													style={{
														textDecoration: 'none',
													}}
												>
													<Typography
														variant='subtitle1'
														className={
															darkMode ? classes.date : classes.lightDate
														}
													>
														{post.createdAt} -{' '}
														{Math.round(post.body.body.split(' ').length / 200)}{' '}
														min read
													</Typography>
												</Link>
											</Grid>
										</Grid>
									</Grid>
								</Grid>
							</Grid>
						</Grid>
					)
				})}
			</Grid>
		</Grid>
	)
}
